import { FormEvent } from "react"
import { Link, useForm, usePage } from "@inertiajs/react"
import { StaffLayout } from "@/components/layouts/staff-layout"
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { MainContainer } from "@/components/ui/container"
import { PageHeader } from "@/components/ui/headers"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { t } from "@/lib/i18n"
type StatusOption = {
    value: string
    label: string
}
type FormTable = {
    name?: string
    seats?: number
    status?: string
}
function errorMessage(value: string | string[] | undefined): string | null {
    if (!value)
        return null
    return Array.isArray(value) ? value[0] : value
}
export default function StaffLocationManageTablesNew() {
    const { statuses, table } = usePage<{
        statuses: StatusOption[]
        table?: FormTable
    }>().props
    const { data, setData, post, errors, processing } = useForm<{
        name: string
        seats: string
        status: string
    }>({
        name: table?.name || "",
        seats: table?.seats ? String(table.seats) : "4",
        status: table?.status || "available",
    })
    const baseError = errorMessage((errors as Record<string, string | string[] | undefined>).base)
    const handleSubmit = (event: FormEvent) => {
        event.preventDefault()
        post("/manage/tables")
    }
    return (<StaffLayout>
      <MainContainer size="sm">
        <PageHeader title={t("ui.react.pages.staff.location.manage.tables.new.new_table")} description={t("ui.react.pages.staff.location.manage.tables.new.register_table_location_current")}/>

        <Card data-testid="table-form-card">
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-6">
              {baseError && (<p className="rounded-md border border-destructive/20 bg-destructive/5 p-3 text-sm text-destructive">
                  {baseError}
                </p>)}

              <div className="space-y-2">
                <Label htmlFor="name">{t("ui.react.pages.staff.location.manage.tables.new.name")}</Label>
                <Input id="name" value={data.name} onChange={(event) => setData("name", event.target.value)} placeholder={t("ui.react.pages.staff.location.manage.tables.new.table")} required/>
                {errors.name && (<p className="text-sm font-medium text-destructive">{errors.name}</p>)}
              </div>

              <div className="grid gap-4 md:grid-cols-2">
                <div className="space-y-2">
                  <Label htmlFor="seats">{t("ui.react.pages.staff.location.manage.tables.new.seats")}</Label>
                  <Input id="seats" type="number" min="1" step="1" value={data.seats} onChange={(event) => setData("seats", event.target.value)} required/>
                  {errors.seats && (<p className="text-sm font-medium text-destructive">{errors.seats}</p>)}
                </div>

                <div className="space-y-2">
                  <Label htmlFor="status">{t("ui.react.pages.staff.location.manage.tables.new.status")}</Label>
                  <Select value={data.status} onValueChange={(value) => setData("status", value)}>
                    <SelectTrigger id="status" className="w-full">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      {statuses.map((statusOption) => (<SelectItem key={statusOption.value} value={statusOption.value}>
                          {statusOption.label}
                        </SelectItem>))}
                    </SelectContent>
                  </Select>
                  {errors.status && (<p className="text-sm font-medium text-destructive">{errors.status}</p>)}
                </div>
              </div>

              <div className="flex items-center gap-2">
                <Button type="submit" disabled={processing} data-testid="create-table-button">{t("ui.react.pages.staff.location.manage.tables.new.create_table")}</Button>
                <Button asChild variant="outline" type="button">
                  <Link href="/manage/tables">{t("ui.react.pages.staff.location.manage.tables.new.cancel")}</Link>
                </Button>
              </div>
            </form>
          </CardContent>
        </Card>
      </MainContainer>
    </StaffLayout>)
}
